// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__384J5","name":"styles_name__1fkip","phone":"styles_phone__3pR47"};